<template>
  <div class="mt-1 mb-0 anamnesisBlock"
       :id="'an-' + anamnesis.anamnesis_type.shortcode"
       :data-testid="'visit-medical-report-anamnesis-' + anamnesis.anamnesis_type.shortcode"
       :data-anamnesis-text="anamnesis.anamnesis_type.shortcode + ' - ' + anamnesis.anamnesis_type.name">
    <vue-editor :id="'anamnesis' + anamnesis.anamnesis_type.shortcode"
                :class="'anamnesis-editor'"
                v-model="anamnesis.text"
                :editorToolbar="customToolbar"
                :editorOptions="editorSettings">
    </vue-editor>
  </div>
</template>

<script>
  import apiMixin from '@/mixins'
  import _ from 'lodash'
  import { VueEditor } from 'vue2-editor'

  export default {
    name: 'AnamnesisEditor',
    data () {
      return {
        // customToolbar: [
        //   ['bold', 'italic', 'underline', 'strike'],
        //   [{'list': 'ordered'}, {'list': 'bullet'}],
        //   [{'indent': '-1'}, {'indent': '+1'}],
        //   [{'color': []}],
        //   [{'align': []}]
        // ],
        customToolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'indent': '-1'}, {'indent': '+1'}]
        ],
        editorSettings: {
          modules: {
            keyboard: {
              bindings: {
                tab: {
                  key: 9,
                  handler: function (range, context) {
                    //
                  }
                },
                'remove tab': {
                  key: 9,
                  shiftKey: true,
                  collapsed: true,
                  prefix: /\t$/,
                  handler: function () {
                    //
                  }
                }
              }
            }
          }
        },
        textChanged: false,
        anamnesisLoading: false,
        anamnesisPending: false,
        anamnesisError: false
      }
    },
    mixins: [apiMixin],
    props: ['anamnesis', 'forceSave'],
    watch: {
      'anamnesis.text' (newVal, oldVal) {
        this.debouncedSaveAnamnesis(newVal)
        this.textChanged = true
      },
      forceSave (newVal) {
        if (newVal.includes('an-' + this.anamnesis.anamnesis_type.shortcode) && this.textChanged === true) {
          this.saveAnamnesis()
          this.textChanged = false
          this.$emit('saved', 'an-' + this.anamnesis.anamnesis_type.shortcode)
        }
      }
    },
    methods: {
      debouncedSaveAnamnesis: _.debounce(function (string) {
        if (this.textChanged) {
          this.saveAnamnesis()
        }
        this.textChanged = false
      }, 1000),
      saveAnamnesis () {
        let objectToSave = {
          'text': this.anamnesis.text,
          'anamnesis_type_id': this.anamnesis.anamnesis_type.id
          // 'anamnesis_type': {
          //   'id': this.anamnesis.anamnesis_type.id,
          //   '_type': this.anamnesis.anamnesis_type._type
          // }
        }
        this.postAnamnesisByVisit(this.$route.params.visitid, objectToSave)
      }
    },
    components: {
      VueEditor
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Visit/components/AnamnesisEditor.vue?2505c59c